export default function Overline({ children, className = "" }) {
  return (
    <div className={`text-[11px] font-bold uppercase tracking-[0.22em] text-[#A91D22] ${className}`}>
      {children}
    </div>
  );
}
